import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useSite } from "../context/SiteContext";
import { Reveal } from "./Reveal";

export default function Newsletter() {
  const { site } = useSite();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/leads", { email });
      toast.success("Inscrição confirmada. Bem-vindo(a) à evolução.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="border-t border-gold/15 bg-[#0a0a0a]" data-testid="newsletter-section">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-32">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Newsletter</p>
          <h2 className="mt-6 max-w-2xl font-serif text-4xl text-zinc-100 sm:text-5xl">{site.newsletter_title}</h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400">{site.newsletter_text}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <form onSubmit={submit} className="mt-10 flex max-w-xl flex-col gap-4 sm:flex-row" data-testid="newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Seu melhor e-mail"
              className="input-dark flex-1"
              data-testid="newsletter-email-input"
            />
            <button type="submit" disabled={loading} className="btn-gold" data-testid="newsletter-submit-button">
              {loading ? "Enviando…" : "Assinar"} <ArrowRight size={14} />
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
